export function toggleOption<T>(options: T[], value: T) {
  if (options.includes(value)) {
    return options.filter((option) => option !== value);
  }

  return [...options, value];
}
